<template>
  <div class="container type-number">
    <div class="values">
      <span
        class="value"
        :class="{
          active: val === k + 1,
          prev: val - 1 === k + 1,
          next: val + 1 === k + 1,
          prev2: val - 2 === k + 1,
          next2: val + 2 === k + 1,
          prev3: val - 3 === k + 1,
          next3: val + 3 === k + 1
        }"
        v-for="(number, k) in numbers"
        :key="k"
        @click="select(k + 1)"
        >{{ number }}</span
      >
    </div>
    <strong class="unit">{{ data.unit }}</strong>
    <div class="buttons">
      <button @click="minus">
        <img
          alt="minus"
          src="@/assets/minus.svg"
          width="25"
          height="25"
          title=""
        />
      </button>
      <button @click="plus">
        <img
          alt="plus"
          src="@/assets/plus.svg"
          width="25"
          height="25"
          title=""
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Number",
  props: ["data", "value"],
  data() {
    return {
      val: this.value || this.data.min,
      numbers: []
    };
  },
  mounted() {
    this.numbers = this.range(this.data.min * 1, this.data.max * 1 + 1);
    this.changeValue();
  },
  watch: {
    val() {
      this.changeValue();
    }
  },
  methods: {
    range(from, to) {
      return [...Array(to - from)].map((_, i) => i + from);
    },
    changeValue() {
      this.$emit("input", this.val, this.data.name);
    },
    select(i) {
      this.val = i;
    },
    plus() {
      if (this.val < this.data.max) {
        this.val += this.data.step * 1;
      }
    },
    minus() {
      if (this.val > this.data.min) {
        this.val -= this.data.step * 1;
      }
    }
  }
};
</script>

<style lang="scss">
.type-number {
  display: flex;
  flex-direction: column;
  .values {
    position: relative;
    width: 100%;
    height: 100%;
    flex-grow: 2;
    min-height: 155px;
    display: flex;
    overflow: hidden;
    white-space: nowrap;
    justify-content: center;
    .value {
      display: inline-block;
      position: absolute;
      left: 50%;
      top: 50%;
      box-sizing: border-box;
      width: 100%;
      max-width: 12rem;
      text-align: center;
      font-family: $number;
      font-weight: 400;
      font-size: 8rem;
      line-height: 10rem;
      padding: 0 1rem;
      opacity: 0;
      user-select: none;
      color: $black;
      white-space: nowrap;
      transition: all 0.4s ease-in-out;
      transform: translate(-50%, -50%) scale(0);
      cursor: pointer;
      z-index: 2;

      &.active {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
      }
      &.prev {
        opacity: 0.5;
        transform: translate(-100%, -50%) scale(0.4);
        z-index: 3;
      }

      &.next {
        opacity: 0.5;
        transform: translate(0%, -50%) scale(0.4);
        z-index: 3;
      }

      &.prev2 {
        opacity: 0.15;
        transform: translate(-150%, -50%) scale(0.4);
        z-index: 3;
      }

      &.next2 {
        opacity: 0.15;
        transform: translate(50%, -50%) scale(0.4);
        z-index: 3;
      }

      &.prev3 {
        opacity: 0;
        transform: translate(-200%, -50%) scale(0.4);
      }

      &.next3 {
        opacity: 0;
        transform: translate(100%, -50%) scale(0.4);
      }
    }
  }

  .buttons {
    display: flex;
    // height: 75%;
    // flex-grow: 1;
    position: relative;
    width: 100%;

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px 0 0 10px;
      width: calc(100vw / 2 - 16px);
      //height: 100%;
      min-height: 50px;
      max-width: 172px;
      max-height: 172px;
      background: $white;
      border: 0;
      &:nth-child(2) {
        border-radius: 0 10px 10px 0;
      }
    }
    &:after {
      content: "";
      position: absolute;
      border-radius: 1px;
      left: 50%;
      top: 50%;
      width: 2px;
      height: 3.6rem;
      background: $lightgray;
      opacity: 0.5;
      transform: translate(-50%, -50%);
    }
  }
  @media screen and (min-width: $breakpoint) {
    .buttons {
      width: auto;
      button {
        width: 104px;
        height: 104px;
        &:nth-child(2) {
        }
      }
    }
  }
}
</style>
